// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__25gja","info":"PatientInfo_info__3TEQM"};